import Api from 'libs/api/index';

class AuthApi extends Api {
  constructor() {
    super('auth');
  }

  signIn = (params) => {
    return this.buildQuery('post', params, 'signin');
  };

  signUp = (params) => {
    return this.buildQuery('post', params, 'sign-up');
  };

  updatePassword = params => {
    return this.buildQuery('put', params, 'password');
  };
}

export default AuthApi;
